module.exports = __webpack_public_path__ + "img/bentley-contiental-gt.6e2e4e29.png";